/**
 * Extracts airline code from airline name string
 * @param airlineName - The airline name in format "Airline Name (CODE)"
 * @returns The airline code or null if not found
 * @example
 * extractAirlineCode("Emirates (EK)") => "EK"
 * extractAirlineCode("Air India (AI)") => "AI"
 */
export const extractAirlineCode = (airlineName: string | null | undefined): string | null => {
  if (!airlineName) {
    return null;
  }

  // Extract code from parentheses using regex
  const match = airlineName.match(/\(([^)]+)\)/);
  return match ? match[1] : null;
};

